import Vue from 'vue';
import axios from 'axios';
import VueGeolocation from 'vue-browser-geolocation';
import Loading from 'vue-loading-overlay';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import { ToggleButton } from 'vue-js-toggle-button'
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import GmapCustomMarker from 'vue2-gmap-custom-marker';
import Snotify, { SnotifyPosition } from 'vue-snotify';
import 'vue-snotify/styles/material.css';
import { getSunrise, getSunset } from 'sunrise-sunset-js';
import * as VueGoogleMaps from 'vue2-google-maps';
import * as moment from 'moment';
import dayMapStyle from '../../../json/dayStyle.json'
import darkMapStyle from '../../../json/darkStyle.json'
import VueObserveVisibility from 'vue-observe-visibility'

const popupOptions = {
    toast: {
        position: SnotifyPosition.centerBottom
    }
}

Vue.use(VueGeolocation);
Vue.use(Loading);
Vue.use(Snotify, popupOptions);
Vue.use(VueObserveVisibility);

Vue.component('ToggleButton', ToggleButton)
Vue.component('multiselect', Multiselect);

Vue.use(VueGoogleMaps, {
    load: {
        v: '3.63',
        key: 'AIzaSyB2AR_DQXGIBLWEnzlKAIVQhngBPvjYmCs',
        loading: 'async',
        region: 'NO',
        language: 'no',
        libraries: 'places'
    }
});

Vue.filter('toUpper', function (value) {
    if (typeof value === 'string' || value instanceof String) {
        return value.toUpperCase();
    }
});

Vue.filter('formatName', function (value) {
    switch (value) {
        case "L":
            return "Levendelagringsmerd";
        case "M":
            return "Fiskemottak";
        case "N":
            return "Nøytralt fryselager";
        case "O":
            return "Leppefisk mottak";
        case "P":
            return "Fiskemottak";
        case "T":
            return "Andre mottak";
        default:
            return "Andre mottak";
    }
});

Vue.filter('formatColor', function (value) {
    switch (value) {
        case "Fiskemottak":
            return "redBackground";
        case "Nøytralt fryselager":
            return "orangeBackground";
        case "Levendelagringsmerd":
            return "darkGreenBackground";
        case "Leppefisk mottak":
            return "yellowBackground";
        case "Andre mottak":
            return "greenBackground";
        default:
            return "";
    }
});

Vue.filter('formatPhone', function (value) {
    if (typeof value === 'string' || value instanceof String) {
        return value.replace(/\B(?=(\d{2})+(?!\d))/g, " ");
    }
});

var dayStyle = dayMapStyle

var darkStyle = darkMapStyle

var app = new Vue({
    el: '#staticMap',

    components: {
        Loading,
        'gmap-custom-marker': GmapCustomMarker,
        'gmap-cluster': VueGoogleMaps.Cluster,
        Multiselect
    },

    data: {
        interval: undefined,
        mapStyle: { mapTypeControl: false, styles: dayStyle },
        dayStyle: { mapTypeControl: false, styles: dayStyle },
        darkStyle: { mapTypeControl: false, styles: darkStyle },
        darkMode: false,
        showList: false,
        showTraders: false,
        showModal: false,
        mapCenter: { lat: 69.651621, lng: 18.959998 },
        markerOptions: {
            url: '../../../img/icons/map/RFLcolors/gmapMarker_red.png',
            scaledSize: { width: 27, height: 43, f: 'px', b: 'px', },
        },
        myCoordinates: {
            lat: null,
            lng: null
        },
        manualPosition: false,
        positionFixed: false,
        geoLocationEnabled: true,
        markers: [],
        filteredMarkers: [],
        mapMarkers: [],
        selectedZones: null,
        traders: [],
        infoPosition: null,
        infoContent: null,
        infoOpened: false,
        infoCurrentKey: null,
        infoOptions: {
            pixelOffset: {
                width: 0,
                height: -35
            },
            content: '<h3></h3>',
            closeBoxMargin: "10px 20px 2px 2px"
        },
        customName: null,
        customLat: null,
        customLng: null,
        searchMarkerString: '',
        searchTraderString: '',
        inRange: false,
        rangeSet: false,
        distanceRange: 100,
        type1: true,
        type2: true,
        type3: true,
        type4: true,
        type5: true,
        elToScroll: null,
        isMapApiError: false,
        iFrameKey: 1,
    },

    computed: {
        iFrameSrc() {
            return "https://www.google.com/maps/embed/v1/place?key=AIzaSyBUkUxcaqknp8CD-ukCsxmUWimfud7l3ts&q=" + this.infoPosition.lat + "," + this.infoPosition.lng +  "&center=" + this.infoPosition.lat + "," + this.infoPosition.lng + "&zoom=13&language=no";
        },

        filteredTraders: function () {
            var searchCriteria = this.searchTraderString.toLowerCase();
            return this.traders.filter(trader => trader.Name.toLowerCase().includes(searchCriteria) || trader.Address.toLowerCase().includes(searchCriteria) || trader.City.toLowerCase().includes(searchCriteria));
        },

        availableZones: function () {
            return [...new Set(this.filteredMarkers.map(marker => marker.zone))]; 
        }
    },

    watch: {
        myCoordinates: function (val) {
            var self = this;
            self.closeMyPosInfo();
            if (val.lng && val.lat) {
                if (!self.rangeSet) {
                    //self.inRange = true;
                    //self.rangeSet = true;
                }
                var array = self.markers;
                array.forEach(function (element) {
                    var dist = self.getDistance(val.lat, val.lng, element.lat, element.lng, 'K');
                    element.dist = dist;
                });
                self.filteredMarkers = array;
                if (self.myCoordinates) {
                    //this.centerMyPosition();
                }
            }
            this.searchMarkers(this.searchMarkerString);
        },

        type1: function (val) {
            this.searchMarkers(this.searchMarkerString);
        },

        type2: function (val) {
            this.searchMarkers(this.searchMarkerString);
        },

        type3: function (val) {
            this.searchMarkers(this.searchMarkerString);
        },

        type4: function (val) {
            this.searchMarkers(this.searchMarkerString);
        },

        type5: function (val) {
            this.searchMarkers(this.searchMarkerString);
        },

        //removes highlight from marker when info window on map is closed
        infoOpened: function (val) {
            if (!val) {
                this.infoCurrentKey = null;
            }
        },

        searchMarkerString: function (val) {
            this.searchMarkers(val);
        },

        markers: function (val) {
            this.recalculateDistance();
            this.filteredMarkers = val;
            this.searchMarkers(this.searchMarkerString);
        },

        filteredMarkers: function (val) {
            var data = val.map(item => {
                return Object.freeze(item);
            });
            this.mapMarkers = data;
        },

        inRange: function (val) {
            this.rangeSet = true;
            this.searchMarkers(this.searchMarkerString);
        },

        distanceRange: function (val) {
            this.searchMarkers(this.searchMarkerString);
        },

        manualPosition: function (val) {
            if (!val) {
                this.positionFixed = false;
                this.getMyPosition();
            }
        },

        darkMode: function (val) {
            if (val) {
                this.mapStyle = this.darkStyle;
            }
            else {
                this.mapStyle = this.dayStyle;
            }
        },

        showTraders: function () {
            if (this.traders.length === 0) {
                this.getTraders();
            }
        },

        infoPosition: function (val) {
            if (val !== null) {
                this.forceRerender();
            }     
        },
    },

    methods: {
        getMarkers: function () {
            let loader = this.$loading.show({
                loader: 'spinner',
                color: '#007bff'
            });
            axios.get('/umbraco/Surface/Map/GetData/')
                .then((response) => {
                    if (response.data !== 'error') {
                        //console.log(response.data);
                        this.markers = response.data;
                    }
                    else {
                        this.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                    }
                    loader.hide();
                })
                .catch(function (error) {
                    console.log(error);
                    loader.hide();
                });
        },

        getTraders: function () {
            let loader = this.$loading.show({
                loader: 'spinner',
                color: '#007bff'
            });
            axios.get('/umbraco/Surface/Map/GetTraders/')
                .then((response) => {
                    if (response.data !== 'error') {
                        // console.log(response.data);
                        this.traders = response.data;
                    }
                    else {
                        this.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                    }
                    loader.hide();
                })
                .catch(function (error) {
                    console.log(error);
                    loader.hide();
                });
        },

        toogleViewMode: function () {
            var self = this;
            self.showList = !self.showList
        },

        toogleSwitch: function (checkbox) {
            var self = this;
            self[checkbox] = !self[checkbox];
        },

        toogleManualLocation: function () {
            var self = this;
            self.manualPosition = !self.manualPosition;
        },

        toogleMapMode: function () {
            var self = this;
            self.darkMode = !self.darkMode
        },

        toogleModal: function () {
            var self = this;
            self.showModal = !self.showModal;
        },

        getPosition: function (marker) {
            return {
                lat: parseFloat(marker.lat),
                lng: parseFloat(marker.lng)
            };
        },

        toggleInfo: function (marker, key, center, scroll) {
            var distString = marker.dist !== 0 ? '<div>Dist: ' + marker.dist + ' km</div>' : ""
            var typeString = marker.type !== undefined ? '<div>Type: ' + marker.type + '</div>' : ""

            var emailString = marker.email !== '' ? `<div>Epost:<a href = "mailto:${marker.email}" > ${marker.email}</a ></div >` : ""
            var contactString = marker.contact !== '' ? '<div>Kontakt: ' + marker.contact + '</div>' : ""
            var mobileString = marker.mobile !== '' ? `<div>Mobil:<a href = "tel:${marker.mobile}" > ${this.$options.filters.formatPhone(marker.mobile)}</a ></div >` : ""
            this.infoPosition = this.getPosition(marker);
            this.infoOptions.content = '<div class="py-3 px-2"><h6><b>' + marker.name + '</b></h6><div class="mb-2">' + distString + typeString + '</div>' + contactString + mobileString + emailString + '</div>';
            if (this.infoCurrentKey === key) {
                this.infoOpened = !this.infoOpened;
                this.infoCurrentKey = null;
                this.elToScroll = null;
            } else {
                this.infoOpened = true;
                this.infoCurrentKey = key;
                if (center) {
                    this.centerMap(marker.lat, marker.lng);
                }
            }

            if (scroll) {
                this.scrollToElement(marker.id);
            }

            //this.scrollToTop();
        },

        scrollToElement: function (elName) {
            var el = document.getElementById(elName);
            if (el) {
                el.scrollIntoView(true);
            }

            this.elToScroll = elName;
        },

        toggleMyPosInfo: function (marker, key) {
            this.infoPosition = this.getPosition(marker);
            this.infoOptions.content = '<h6>' + marker.name + '</h6>';
            if (this.infoCurrentKey === key) {
                this.infoOpened = !this.infoOpened;
                this.infoCurrentKey = null;
            } else {
                this.infoOpened = true;
                this.infoCurrentKey = key;
            }
            this.centerMap(marker.lat, marker.lng);
        },

        closeMyPosInfo: function () {
            if (this.infoCurrentKey === 10000) {
                this.infoOpened = !this.infoOpened;
                this.infoCurrentKey = null;
            }
        },

        centerMap: function (lat, lng) {
            this.mapCenter = {
                lat: lat,
                lng: lng
            };
        },

        centerMyPosition: function () {
            if (this.myCoordinates.lat && this.myCoordinates.lng) {
                this.toggleMyPosInfo({ name: 'Min posisjon', dist: 0, lat: this.myCoordinates.lat, lng: this.myCoordinates.lng }, 10000);
            }
        },


        getMyPosition: function () {
            if (!this.manualPosition) {
                this.$getLocation({})
                    .then(coordinates => {
                        if (coordinates.lat !== this.myCoordinates.lat || coordinates.lng !== this.myCoordinates.lng) {
                            this.myCoordinates = coordinates;
                            this.geoLocationEnabled = true;
                        }
                    })
                    .catch(error => {
                        if (this.geoLocationEnabled) {
                            this.geoLocationEnabled = false;
                            alert(error);
                        }
                    });
            }
        },

        searchMarkers: function (searchString) {
            var self = this;
            self.filteredMarkers = [];
            var markersToShow = [];
            var array = self.markers;
            if (this.inRange) {
                array.forEach(function (element) {
                    var str = element.name.toLowerCase();
                    var dist = parseFloat(element.dist);
                    if (str.includes(searchString.toLowerCase()) && dist < self.distanceRange) {
                        markersToShow.push(element);
                    }
                });
            }
            else {
                array.forEach(function (element) {
                    var str = element.name.toLowerCase() + element.id.toLowerCase() + element.zone.toLowerCase();
                    if (str.includes(searchString.toLowerCase())) {
                        markersToShow.push(element);
                    }
                });
            }

            var filteredByType = this.filterByType(markersToShow)

            self.filteredMarkers = this.sortByDist(filteredByType);

            self.infoOpened = false;
            self.infoCurrentKey = null;
        },

        filterByType: function (array) {
            var self = this;
            var filtered = [];

            if (self.type1) {
                var items1 = array.filter(m => m.type === 'Fiskemottak')
                filtered.push(...items1)
            }

            if (self.type2) {
                var items2 = array.filter(m => m.type === 'Nøytralt fryselager')
                filtered.push(...items2)
            }

            if (self.type3) {
                var items3 = array.filter(m => m.type === 'Levendelagringsmerd')
                filtered.push(...items3)
            }

            if (self.type4) {
                var items4 = array.filter(m => m.type === 'Leppefisk mottak')
                filtered.push(...items4)
            }

            if (self.type5) {
                var items5 = array.filter(m => m.type === 'Andre mottak')
                filtered.push(...items5)
            }

            return filtered;

        },

        addLocation: function (isAction = false) {
            if (isAction) {
                this.filteredMarkers.push({
                    name: this.customName,
                    lat: this.customLat,
                    lng: this.customLng
                });
            }
        },

        getDistance: function (lat1, lon1, lat2, lon2, unit) {
            var radlat1 = Math.PI * lat1 / 180;
            var radlat2 = Math.PI * lat2 / 180;
            var theta = lon1 - lon2;
            var radtheta = Math.PI * theta / 180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            dist = Math.acos(dist);
            dist = dist * 180 / Math.PI;
            dist = dist * 60 * 1.1515;
            if (unit === "K") { dist = dist * 1.609344; }
            if (unit === "N") { dist = dist * 0.8684; }
            return Math.round(dist);
        },

        sortByDist: function (markers) {
            return _.orderBy(markers, 'dist', 'asc');
        },

        recalculateDistance: function () {
            var self = this;
            if (self.myCoordinates.lng && self.myCoordinates.lat) {
                var array = self.markers;
                array.forEach(function (element) {
                    var dist = self.getDistance(self.myCoordinates.lat, self.myCoordinates.lng, element.lat, element.lng, 'K');
                    element.dist = dist;
                });
            }
        },

        clearSearch: function () {
            this.searchMarkerString = '';
        },

        mark(event) {
            var self = this;
            if (self.manualPosition && !self.positionFixed) {
                var locationObject = { lat: event.latLng.lat(), lng: event.latLng.lng(), altitude: null, altitudeAccuracy: null, accuracy: 785204 }
                self.myCoordinates = locationObject;
                self.positionFixed = true;
            }
        },

        displayPopup() {
            setTimeout(() => {
                this.$snotify.info('Vi lager nye nettsider å dine tilbakmeldinger er viktig for at vi skal kunne lage en best mulig opplevelse for alle våre brukere.', 'Hjelp oss', {
                    timeout: 30000,
                    showProgressBar: true,
                    closeOnClick: false,
                    pauseOnHover: true,
                    buttons: [
                        { text: 'Ja', action: (toast) => { window.open('https://forms.office.com/Pages/ResponsePage.aspx?id=992mNB4d6UuuE30Ut7woQSToe3hgVQ9LuYP8nlxBFIlUNEJKWUwwSjNLNVlDVElTTzFCRllESjJFUiQlQCN0PWcu&embed=true', '_blank'); this.$snotify.remove(toast.id); }, bold: true },
                        { text: 'Nei', action: (toast) => { this.$snotify.remove(toast.id); }, bold: false },
                    ],
                    placeholder: ''
                });
            }, 10000);
        },

        displayHtmlPopup() {
            setTimeout(() => {
                this.$snotify.html(`<div class="snotifyToast__title"><b>Hjelp oss å bli bedre</b></div><div class="snotifyToast__body">
                                    <p>Vi lager nye nettsider å dine tilbakemeldinger er viktig for at vi skal kunne lage en best mulig opplevelse for alle våre brukere.</p>
                                   `, {
                    timeout: 10000,
                    showProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    buttons: [
                        { text: 'JA', action: (toast) => { window.open('https://forms.office.com/Pages/ResponsePage.aspx?id=992mNB4d6UuuE30Ut7woQSToe3hgVQ9LuYP8nlxBFIlUNEJKWUwwSjNLNVlDVElTTzFCRllESjJFUiQlQCN0PWcu&embed=true', '_blank'); this.$snotify.remove(toast.id); }, bold: true },
                        { text: 'NEI', action: (toast) => { this.$snotify.remove(toast.id); }, bold: false },
                    ],
                    placeholder: ''
                });
            }, 30000);
        },


        sortTable: function (prop) {
            var unsorted = this.filteredMarkers;

            if (this.sortColumn === null || this.sortColumn !== prop) {
                this.sortColumn = prop;
                this.ascSort = true;
            }
            else {
                this.ascSort = !this.ascSort;
            }

            this.filteredMarkers = unsorted.sort(this.dynamicSort(prop, this.ascSort));
        },

        dynamicSort: function (property, asc) {
            var sortOrder = 1;
            if (!asc) {
                sortOrder = -1;
            }
            return function (a, b) {
                /* next line works with strings and numbers, 
                 * and you may want to customize it to your needs
                 */
                var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                return result * sortOrder;
            }
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        },

        // sets dark mode based on sun position
        setMapMode() {
            if (this.myCoordinates.lat && this.myCoordinates.lng) {
                var sunrise = getSunrise(this.myCoordinates.lat, this.myCoordinates.lng);
                var sunset = getSunset(this.myCoordinates.lat, this.myCoordinates.lng);

                if (isNaN(sunrise) || isNaN(sunset)) {
                    var darkMonths = [10, 11, 0, 1];
                    if (darkMonths.includes(moment().month())) {
                        this.darkMode = true;
                    } 
                }
                else if (sunrise > moment.now() && sunset < moment.now()) {
                    this.darkMode = true;
                }
            }
        },

        visibilityChanged(isVisible, entry) {
            var self = this;
            if (isVisible && self.elToScroll !== null) {
                var elMobile = document.getElementById(self.elToScroll + 'mobile');
                if (elMobile) {
                    elMobile.scrollIntoView(true);
                    document.getElementById('mobileModal').scrollTop = 0;
                    
                }
            }
        },

        modalClick(target) {
            if (target.id === 'mobileModal') {
                this.toogleModal();
            }
        },

        forceRerender() {
            this.iFrameKey += 1;
        },

        displayErrorNotification(error) {
            this.$snotify.error(error, {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                position: "rightBottom"
            });
        },
    },

    created() {
        var self = this;
        self.getMyPosition();
        self.interval = setInterval(self.getMyPosition, 30000);

        window.gm_authFailure = () => {
            self.isMapApiError = true;
            self.showList = true;
        };

        window.addEventListener('gmapi_error', function () {
            self.isMapApiError = true;
            self.showList = true;
        });


    },

    beforeDestroy() {
        if (this.interval) {
            clearIntervall(this.interval);
            this.interval = undefined;
        }
    },

    mounted() {
        var self = this;
        self.getMarkers();

        setTimeout(() => {
            if (self.myCoordinates.lat !== null && self.myCoordinates.lng !== null) {
                self.setMapMode();
                self.centerMap(self.myCoordinates.lat, self.myCoordinates.lng)
                self.toggleMyPosInfo({ name: 'Min posisjon', dist: 0, lat: self.myCoordinates.lat, lng: self.myCoordinates.lng }, 10000);
            }
        }, 2000);
       
    }
});


// WEBPACK FOOTER //
// ./Scripts/app/staticMap/index.js